module.exports = {
      id: "forward-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#forward",
      toString: function () {
        return this.url;
      }
    }